import { Theme } from '@aws-amplify/ui-react';

const amplifyTheme: Theme = {
  name: 'amplifyTheme',
  tokens: {
    components: {
      button: {
        primary: {
          backgroundColor: '#ed5233',
        },
      },
      tabs: {
        borderWidth: '3px',
        item: {
          _focus: {
            boxShadow: `0 0 0 5px blue`,
          },
          _active: {
            // color: 'white',
            // backgroundColor: '#09223c',
            borderColor: '#09223c',
          },
        },
      },
    },
  },
};

export { amplifyTheme };
